import { BalancesProps } from './types';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledBalancesLayout } from './style';

export const BalancesLayout = ({ children }: BalancesProps) => {
  return (
    <StyledBalancesLayout>
      <div className="balanceLayoutContainer">{children}</div>
    </StyledBalancesLayout>
  );
};
